module.exports = __webpack_public_path__ + "img/grow1.04c4dae7.png";